module.exports = __webpack_public_path__ + "static/bs-cashless-merchant-users-logos-81db1421a788d5ff5c322205947ec3c4.png";